export default __webpack_public_path__ + "static/media/clock.86c4cfb1.svg";